module.exports = __webpack_public_path__ + "static/media/icon-other.6718dde9.svg";